import { InfoOutlined } from '@mui/icons-material'
import { Stack, Tooltip } from '@mui/material'
import { FC } from 'react'

type Props = {
  label: string
  tooltip: string
}

export const ColumnHeaderWithTooltip: FC<Props> = ({ label, tooltip }) => (
  <Stack direction="row" alignItems="center" gap={0.5}>
    {label}
    <Tooltip title={tooltip} placement="top">
      <InfoOutlined sx={{ color: 'fg.subtle', width: 16, height: 16 }} />
    </Tooltip>
  </Stack>
)
